import React, { useState, useEffect } from 'react';
import axiosInstance from '../api/axiosInstance';
import { useNavigate, Link } from 'react-router-dom';
import './Registration.css';

const Registration = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [username, setUsername] = useState(''); // Username will be auto-filled from email
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    // Hardcoded role and hotelId
    const role = '0';       // Hardcoded role
    const hotelId = 0;         // Hardcoded hotel ID

    // Function to validate form inputs
    const validateForm = () => {
        if (!firstName || !lastName || !email || !password || !confirmPassword) {
            setErrorMessage('All fields are required');
            return false;
        }
        if (password !== confirmPassword) {
            setErrorMessage('Passwords do not match');
            return false;
        }
        // Basic email format check
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email)) {
            setErrorMessage('Invalid email format');
            return false;
        }
        return true;
    };

    // Automatically set the username when the email is updated
    useEffect(() => {
        if (email) {
            setUsername(email);
        }
    }, [email]);

    // Function to handle registration request
    const handleRegister = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setIsLoading(true);
        setErrorMessage('');
        setSuccessMessage('');

        try {
            const response = await axiosInstance.post('/api/user', {
                firstName,
                lastName,
                username, // Auto-filled from email
                email,
                password,
                role,
                hotelId
            });

            if (response.status === 201) {
                setSuccessMessage('Registration successful! Please check your email to confirm your account.');
                setTimeout(() => navigate('/login'), 3000);  // Redirect to login after success
            }
        } catch (error) {
            setErrorMessage(error.response?.data?.message || 'An error occurred during registration.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="registration-container">
            <div className="registration-box">
                <h2>Register</h2>
                <form onSubmit={handleRegister}>
                    <input
                        type="text"
                        placeholder="First Name"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        disabled={isLoading}
                    />
                    <input
                        type="text"
                        placeholder="Last Name"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        disabled={isLoading}
                    />
                    <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={isLoading}
                    />
                    <input
                        type="text"
                        placeholder="Username (auto-filled from email)"
                        value={username}
                        disabled={true}
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        disabled={isLoading}
                    />
                    <input
                        type="password"
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        disabled={isLoading}
                    />

                    <button type="submit" disabled={isLoading}>
                        {isLoading ? 'Registering...' : 'Register'}
                    </button>
                    {errorMessage && <p className="error-message">{errorMessage}</p>}
                    {successMessage && <p className="success-message">{successMessage}</p>}
                </form>

                {/* "Go back to login" link */}
                <p className="back-to-login">
                    Already have an account? <Link to="/login">Go back to login</Link>
                </p>
            </div>
        </div>
    );
};

export default Registration;
